var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.497,
    height: 20.497,
    viewBox: "0 0 20.497 20.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12963",
    "data-name": "Group 12963",
    transform: "translate(39.898 -1.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12962",
    "data-name": "Group 12962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_380",
    "data-name": "Ellipse 380",
    transform: "translate(-39.898 1.847)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.249,
    cy: 10.249,
    r: 10.249,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.249,
    cy: 10.249,
    r: 9.749,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7274",
    "data-name": "Path 7274",
    d: "M3870.945-2745.673c-.062-.037-3.586-3.656-3.661-3.76.019-.022.038-.048.06-.07l1.071-1.091.632-.645c.022-.023.047-.043.079-.073.607.619,1.2,1.239,1.8,1.853.078-.047,2.125-2.153,2.742-2.8.9-.941,1.814-1.871,2.729-2.812.033.029.06.05.083.074l1.224,1.259.471.484.034.035a.044.044,0,0,1,0,.071c-.026.027-.051.056-.078.083l-1.554,1.6-2.221,2.286-1.631,1.68-1.722,1.774C3870.984-2745.705,3870.963-2745.689,3870.945-2745.673Z",
    transform: "translate(-3902.684 2762.465)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.f66a1820d27c516827e2343ebb1eabf1.svg";
export { ForwardRef as ReactComponent };